import React from "react";

export default function Stats() {
    return (
        <div className="flex flex-cols-5 gap-4 text-center ">
            <div>
                <span className="text-3xl font-bold">124+</span>
                <p className="text-gray-400">Machines modernes</p>
            </div>
            <div className="w-1 h-100 bg-gray-300"></div>
            <div>
                <span className="text-3xl font-bold">25+</span>
                <p className="text-gray-400">Cours par semaine</p>
            </div>
            <div className="w-1 h-100 bg-gray-300"></div>
            <div>
                <span className="text-3xl font-bold">7J/7</span>
                <p className="text-gray-400"> Lundi au dimanche</p>
            </div>
        </div>
    )
}